(function ($) {
    'use strict';

    $.b2b = $.b2b || {};

    function getCsrfToken() {
        return $('#csrfTokenContainer input[name="__RequestVerificationToken"]').val();
    }

    function isSameOrigin(url) {
        if (!url) {
            return true;
        }
        var anchor = document.createElement('a');
        anchor.href = url;
        if (!anchor.host) {
            anchor.href = anchor.href;
        }
        return anchor.protocol === window.location.protocol && anchor.host === window.location.host;
    }

    function isUnsafeMethod(method) {
        if (!method) {
            return false;
        }
        method = String(method).toUpperCase();
        return method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH';
    }

    function shouldAttachToken(url, method) {
        return isSameOrigin(url) && isUnsafeMethod(method);
    }

    $.b2b.csrf = {
        getToken: getCsrfToken,
        isSameOrigin: isSameOrigin,
        shouldAttachToken: shouldAttachToken
    };

    // Prefilter сразу после jQuery, до остальных скриптов. Токен читаем в момент запроса.
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (options.crossDomain || !isUnsafeMethod(options.type)) {
            return;
        }

        var csrfToken = getCsrfToken();
        if (csrfToken) {
            jqXHR.setRequestHeader('RequestVerificationToken', csrfToken);
        }
    });
})(jQuery);
